import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause, ExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { GeocodingTaskContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';
import { GeocodingTasks } from '../resources/GeocodingTasks';

export const GeocodingTaskDefinition: ExplorableItemDefinition = {
  itemType: 'addressGeocodingTask',
  pluralName: Messages.geocodingTasks,
  singularName: Messages.geocodingTask,
  emptyStateMessage: Messages.geocodingTasksEmptyMessage,
  contentFilterKeys: GeocodingTaskContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconType: null,
  filterClause: ServerFilterClauses.ContentType(['addressGeocodingTask']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return GeocodingTasks.all();
  },
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for geocodingTask');
  },
  supportedDisplayModes: ['list']
};
